import { render, staticRenderFns } from "./ArticleTipDialog.vue?vue&type=template&id=308321cd&scoped=true"
import script from "./ArticleTipDialog.vue?vue&type=script&lang=js"
export * from "./ArticleTipDialog.vue?vue&type=script&lang=js"
import style0 from "./ArticleTipDialog.vue?vue&type=style&index=0&id=308321cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308321cd",
  null
  
)

export default component.exports